import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
type PackOption = 'basic' | 'complete';
export function CheckoutSection() {
  const [selected, setSelected] = useState<PackOption>('complete');
  const includes = ['4 Módulos Clínicos (300 actividades técnicas)', 'Bono 1 — Protocolo de Ingreso y Screening Rápido', 'Bono 2 — Planificador de Sesiones y Evolución', 'Bono 3 — Kit de Cartelería: Orientación a la Realidad', 'Bono 4 — Guía de Alertas: Cuándo derivar al Neurólogo', 'Súper Bono 5 — Módulo Adolescentes 12-18 años', 'Súper Bono 6 — Módulo Adultos 20-50 años'];
  const packs = {
    basic: {
      label: 'KIT CLÍNICO',
      icon: '📘',
      description: '4 módulos + 4 bonos + 2 súper bonos',
      oldPrice: '$79.000',
      price: '$19.990',
      checkoutUrl: 'https://cognitivocheck.librosdigitales.pro/cart/52523328209183:1',
      ctaText: 'SÍ, QUIERO EL KIT CLÍNICO'
    },
    complete: {
      label: 'KIT COMPLETO',
      icon: '🏆',
      description: 'Kit Clínico + Historias de mi Puño y Letra',
      oldPrice: '$88.000',
      price: '$27.990',
      checkoutUrl: 'https://cognitivocheck.librosdigitales.pro/cart/52523333189919:1',
      ctaText: 'SÍ, QUIERO EL KIT COMPLETO'
    }
  };
  const current = packs[selected];
  return <section id="checkout" className="py-16 sm:py-24 bg-gradient-to-b from-amber-50 via-cream-50 to-orange-50" data-id="element-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-2xl p-6 sm:p-10" data-id="element-34">
          <div className="text-center mb-8" data-id="element-35">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3" data-id="element-36">
              Elegí tu <span className="text-teal-700" data-id="element-37">KIT CLÍNICO</span>
            </h2>
            <p className="text-gray-600" data-id="element-38">
              Todas las opciones incluyen los 4 módulos, los 4 bonos y los 2
              súper bonos
            </p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-39">
            {/* BASIC PACK */}
            <button type="button" onClick={() => setSelected('basic')} className={`w-full text-left rounded-xl p-5 sm:p-6 transition-all duration-300 border-2 ${selected === 'basic' ? 'border-teal-600 bg-teal-50 shadow-lg' : 'border-gray-200 bg-white hover:border-teal-300 hover:bg-gray-50'}`} data-id="element-40">
              <div className="flex items-center gap-4" data-id="element-41">
                <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'basic' ? 'border-teal-600 bg-teal-600' : 'border-gray-300'}`} data-id="element-42">
                  {selected === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-43" />}
                </div>
                <div className="flex-1 min-w-0" data-id="element-44">
                  <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-45">
                    <span className="text-2xl" data-id="element-46">{packs.basic.icon}</span>
                    <span className="font-bold text-gray-900 text-lg" data-id="element-47">
                      {packs.basic.label}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-48">
                    {packs.basic.description}
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-49">
                  <p className="text-xs text-gray-400 line-through" data-id="element-50">
                    {packs.basic.oldPrice}
                  </p>
                  <p className="text-2xl sm:text-3xl font-bold text-gray-900" data-id="element-51">
                    {packs.basic.price}
                  </p>
                </div>
              </div>
            </button>

            {/* COMPLETE PACK */}
            <button type="button" onClick={() => setSelected('complete')} className={`w-full text-left rounded-xl p-5 sm:p-6 transition-all duration-300 border-2 relative ${selected === 'complete' ? 'border-amber-500 bg-amber-50 shadow-lg' : 'border-gray-200 bg-white hover:border-amber-300 hover:bg-gray-50'}`} data-id="element-52">
              <div className="flex items-center gap-4" data-id="element-53">
                <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'complete' ? 'border-amber-500 bg-amber-500' : 'border-gray-300'}`} data-id="element-54">
                  {selected === 'complete' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-55" />}
                </div>
                <div className="flex-1 min-w-0" data-id="element-56">
                  <div className="flex items-center gap-2 mb-2 flex-wrap" data-id="element-57">
                    <span className="text-2xl" data-id="element-58">{packs.complete.icon}</span>
                    <span className="font-bold text-gray-900 text-lg" data-id="element-59">
                      {packs.complete.label}
                    </span>
                    <span className="inline-flex items-center gap-1 bg-amber-500 text-white text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-60">
                      <Star className="w-3 h-3 fill-white" data-id="element-61" /> MÁS ELEGIDO
                    </span>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-62">
                    {packs.complete.description}
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-63">
                  <p className="text-xs text-gray-400 line-through" data-id="element-64">
                    {packs.complete.oldPrice}
                  </p>
                  <p className="text-2xl sm:text-3xl font-bold text-amber-600" data-id="element-65">
                    {packs.complete.price}
                  </p>
                </div>
              </div>

              {/* Order bump details for complete pack */}
              {selected === 'complete' && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} transition={{
              duration: 0.3
            }} className="mt-4 pt-4 border-t border-amber-200" data-id="element-66">
                  <p className="text-sm font-semibold text-amber-800 mb-2" data-id="element-67">
                    💛 Incluye además: "HISTORIAS DE MI PUÑO Y LETRA"
                  </p>
                  <p className="text-sm text-gray-700 mb-2" data-id="element-68">
                    La herramienta definitiva de Terapia de Reminiscencia. Un
                    cuadernillo guiado para que el paciente escriba su historia
                    de vida con su propio puño y letra.
                  </p>
                  <p className="text-sm text-gray-700" data-id="element-69">
                    Y además{' '}
                    <span className="font-semibold text-amber-800" data-id="element-70">
                      6 tomos con 48 ejercicios cotidianos para el mayor
                    </span>
                    , pensados para integrar la estimulación a la rutina diaria
                    del paciente en casa.
                  </p>
                </motion.div>}
            </button>
          </div>

          {/* CTA Button */}
          <motion.a key={selected} href={current.checkoutUrl} initial={{
          opacity: 0,
          y: 5
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className={`block w-full text-center px-8 py-5 text-lg sm:text-xl font-bold rounded-xl shadow-lg transition-all duration-300 text-white ${selected === 'complete' ? 'bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700' : 'bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800'}`} data-id="element-71">
            {current.ctaText} →
          </motion.a>

          <p className="text-center text-sm text-gray-500 mt-4 italic" data-id="element-72">
            Podés sumar el otro pack cuando quieras
          </p>

          <p className="text-center text-sm text-gray-600 mt-6" data-id="element-73">
            🔒 Pago seguro · Acceso inmediato · Garantía de 7 días
          </p>

          {/* What's included */}
          <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-74">
            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide mb-4" data-id="element-75">
              {current.label} incluye:
            </h3>
            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-76">
              {includes.map((item, index) => <li key={index} className="flex items-start gap-2" data-id="element-77">
                  <Check className="w-4 h-4 text-teal-600 flex-shrink-0 mt-1" data-id="element-78" />
                  <span className="text-sm text-gray-700" data-id="element-79">{item}</span>
                </li>)}
              {selected === 'complete' && <>
                  <li className="flex items-start gap-2 sm:col-span-2" data-id="element-80">
                    <Check className="w-4 h-4 text-amber-600 flex-shrink-0 mt-1" data-id="element-81" />
                    <span className="text-sm font-semibold text-amber-800" data-id="element-82">
                      💛 Historias de mi Puño y Letra (Terapia de Reminiscencia)
                    </span>
                  </li>
                  <li className="flex items-start gap-2 sm:col-span-2" data-id="element-83">
                    <Check className="w-4 h-4 text-amber-600 flex-shrink-0 mt-1" data-id="element-84" />
                    <span className="text-sm text-amber-800" data-id="element-85">
                      <span className="font-semibold" data-id="element-86">
                        📚 6 tomos con 48 ejercicios cotidianos para el mayor
                      </span>
                      <span className="block font-normal text-gray-700 mt-1" data-id="element-87">
                        Para que el paciente se los lleve a casa y los realice
                        solo o acompañado por su familia, sosteniendo la
                        estimulación entre sesiones.
                      </span>
                    </span>
                  </li>
                </>}
            </ul>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 text-center" data-id="element-88">
            <p className="text-gray-700 leading-relaxed text-sm" data-id="element-89">
              Kit Clínico Cognitivo™ — Porque tu práctica profesional merece un
              sistema, no una carpeta de actividades sueltas.
            </p>
            <p className="text-xs text-gray-500 mt-3" data-id="element-90">
              Acceso inmediato · Descarga en PDF · Acceso de por vida
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}